/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */
import socketAPI from './socket';
import actionHandler from './actionHandler';
import { API_LIVECHAT_URL } from '../constants/env';

const socketApi = new socketAPI(API_LIVECHAT_URL);

const handler = new actionHandler();

export { socketApi, handler };
